import { WebStorageStateStore } from "oidc-client-ts";

// react-oidc-context / oidc-client-ts settings for the Authorization Code + PKCE
// flow against the backend's Authorization Server (see docs/specs/0001-oidc-migration.md,
// ADR-0001). Values are supplied per environment via REACT_APP_OIDC_* env vars,
// built against the backend's parallel-running new login path (portal ticket 02).
const defaultAuthority = process.env.REACT_APP_OIDC_AUTHORITY || "http://localhost:8000/api/openid";
const defaultRedirectUri = process.env.REACT_APP_OIDC_REDIRECT_URI || "http://localhost:3000/";

const oidcConfig = {
  authority: defaultAuthority,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID || "portal-ui",
  redirect_uri: defaultRedirectUri,
  // Where the Authorization Server sends the browser back after RP-initiated
  // logout (see ticket 06) - defaults to the sign-in page itself.
  post_logout_redirect_uri:
    process.env.REACT_APP_OIDC_POST_LOGOUT_REDIRECT_URI || defaultRedirectUri,
  // offline_access asks the Authorization Server to issue a refresh_token,
  // which is what lets silent renewal (ticket 05) use a plain refresh-token
  // exchange instead of an iframe-based prompt=none redirect.
  scope: process.env.REACT_APP_OIDC_SCOPE || "openid profile email offline_access",
  // The Scope claim rides on the token itself (see CONTEXT.md) - no userinfo round trip needed.
  loadUserInfo: false,
  // Persist signed-in user tokens in localStorage so authentication is shared across browser tabs.
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Disable automatic background timer renewals in oidc-client-ts.
  // Token renewal is handled strictly on-demand by Axios 401 response interceptor.
  automaticSilentRenew: false,
};

export default oidcConfig;
